// Support ticket status enum
export var SupportTicketStatus;
(function (SupportTicketStatus) {
    SupportTicketStatus["OPEN"] = "open";
    SupportTicketStatus["WAITING_FOR_USER"] = "waiting_for_user";
    SupportTicketStatus["WAITING_FOR_STAFF"] = "waiting_for_staff";
    SupportTicketStatus["RESOLVED"] = "resolved";
    SupportTicketStatus["CLOSED"] = "closed";
})(SupportTicketStatus || (SupportTicketStatus = {}));
// Support ticket type enum
export var SupportTicketType;
(function (SupportTicketType) {
    SupportTicketType["SUGGESTION"] = "suggestion";
    SupportTicketType["REQUEST"] = "request";
    SupportTicketType["COMPLAINT"] = "complaint";
})(SupportTicketType || (SupportTicketType = {}));
// Helper types for display labels
export const SUPPORT_TICKET_STATUS_LABELS = {
    [SupportTicketStatus.OPEN]: "Open",
    [SupportTicketStatus.WAITING_FOR_USER]: "Waiting for User",
    [SupportTicketStatus.WAITING_FOR_STAFF]: "Waiting for Staff",
    [SupportTicketStatus.RESOLVED]: "Resolved",
    [SupportTicketStatus.CLOSED]: "Closed",
};
export const SUPPORT_TICKET_TYPE_LABELS = {
    [SupportTicketType.SUGGESTION]: "Suggestion",
    [SupportTicketType.REQUEST]: "Request",
    [SupportTicketType.COMPLAINT]: "Complaint",
};
// Helper function to get support ticket display title
export const getSupportTicketDisplayTitle = (ticket) => {
    return ticket.title;
};
// Helper function to get support ticket status color class
export const getSupportTicketStatusColor = (status) => {
    switch (status) {
        case SupportTicketStatus.OPEN:
            return "text-blue-600";
        case SupportTicketStatus.WAITING_FOR_USER:
            return "text-orange-600";
        case SupportTicketStatus.WAITING_FOR_STAFF:
            return "text-yellow-600";
        case SupportTicketStatus.RESOLVED:
            return "text-green-600";
        case SupportTicketStatus.CLOSED:
            return "text-gray-600";
        default:
            return "text-gray-600";
    }
};
//# sourceMappingURL=SupportTicket.js.map